import React, { Component } from 'react';
import { EventEmitter } from 'fbemitter';
import PropTypes from 'prop-types';

import auth from './Containers/Authentication/Auth';
import Navigation from './Containers/Navigation/Navigation';

import MarketingRoutes from './Containers/Marketing/MarketingRoutes';

import Main from './Main';

import './App.css';

const authEvents = new EventEmitter();

class App extends Component {
  constructor(props) {
    super(props);

    auth.logoutCallback(() => {
      this.context.router.history.push('/login');
      authEvents.emit('loggedout');
    });

    auth.loginCallback(() => {
      authEvents.emit('loggedIn');
    });

    if (auth.loggedIn()) {
      authEvents.emit('loggedIn');
    } else {
      authEvents.emit('loggedout');
    }

    this.state = {
      drawerOpen: false,
    };
  }

  handleToggle() {
    this.setState({ drawerOpen: !this.state.drawerOpen });
  }

  renderMarketing() {
    return (
      <div className="app">
        <div id="mobile-nav-overlay" />
        {/* TODO: add mobile nav here */}
        <MarketingRoutes />
      </div>
    );
  }

  renderApp() {
    return (
      <div className="app">
        <div id="mobile-navigation">
          <div className="mobile-navigation-content">
            <nav>
              <ul>
                <li><a href="/orders" className="orders">Orders</a></li>
                <li><a href="/fuelfarm" className="fuelfarm">Fuel Farm</a></li>
                <li><a href="/fueltrucks" className="fueltrucks">Fuel Trucks</a></li>
                <li><a href="/reports" className="reports">Reports</a></li>
                <li><a href="/settings" className="settings">Settings</a></li>
                <li className="current-user">
                  {`${auth.getCurrentUser().firstName} ${auth.getCurrentUser().lastName}`}
                  <ul>
                    <li><a href="#edit-profile" className="hide">Edit Profile</a></li>
                    <li><a href="/logout">Logout</a></li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <Navigation />
        <Main />
      </div>
    );
  }

  render() {
    let renderFunc = this.renderMarketing();

    if (auth.loggedIn()) {
      renderFunc = this.renderApp();
    }

    return (renderFunc);
  }
}

// App.contextTypes = {
//   router: React.PropTypes.object
// };

App.contextTypes = {
  router: PropTypes.object
};

export default App;




// WEBPACK FOOTER //
// ./src/App.js